module.exports = __webpack_public_path__ + "static/penguinsuitcase-eb69a16ff35584bb492080ecfb868fa2.jpeg";